import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { authProvider } from "../../../../../authProvider";
import { finalDeliberations } from "../../../../../services/formCombos.service.js";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { makeStyles, Grid, Fab } from "@material-ui/core";
import ReviewsModal from "./ReviewsModal";
import ModalBase from "../../../utils/ModalBase";
import { Add, Clear } from "@material-ui/icons";
import { getById } from "../../../../../services/minutes.service";
import { getMembersByName } from "../../../../../services/formCombos.service.js";
import { Select } from "../../../../Common/Select";
import { actionShowSpinner } from "../../../../../redux-flow/action/Wrapper/Spinner";
import Toastmessage from "../../../../Common/ToastMessage";
import {
  addFinalDeliberation,
  addFinalDeliberationRevision,
} from "../../../../../services/minutes.service";
import { useAuth } from "../../../../../context/auth";
import { checkAccess } from "../../../utils/index";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  subtitle: {
    ...theme.typography.subtitle1,
  },
  button: {
    fontSize: "1rem",
    fontWeight: "bold",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20,
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.25rem",
    color: theme.palette.primary.main,
    marginBottom: 20,
  },
}));

const FinalDeliberation = ({
  t,
  minuteStatus,
  finalDeliberation,
  setFinalDeliberation,
  minuteSlotId,
  isEditMode = true,
}) => {
  const classes = useStyles();
  const { userAccess } = useAuth();

  const [message, setMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });
  const [formMode, setFormMode] = useState("create");
  const [finalDeliberationInputValue, setFinalDeliberationInputValue] =
    useState("");
  const [finalDeliberationReviews, setfinalDeliberationReviews] = useState([]);

  const [openReviewsModal, setOpenReviewsModal] = useState(false);
  const [inputReviewerRequester, setInputReviewerRequester] = useState("");
  const [reviewerRequester, setReviewerRequester] = useState();
  const [reviewRequesters, setReviewRequesters] = useState([]);

  const [canCreateDeliberation, setCanCreateDeliberation] = useState(false);
  const [canCreateDeliberationReview, setCanCreateDeliberationReview] =
    useState(false);

  useEffect(() => {
    async function load() {
      if (inputReviewerRequester?.length >= 3) {
        const res = await getMembersByName("pt", inputReviewerRequester);

        if (res.error?.length > 0) {
          setReviewRequesters([]);
        }

        const list = res.data;

        setReviewRequesters(list);
      } else {
        setReviewRequesters([]);
      }
    }

    if (userAccess) {
      const hasAccessToCreateDeliberation = checkAccess(
        userAccess,
        "createDeliberation"
      );
      const hasAccessToCreateDeliberationReview = checkAccess(
        userAccess,
        "createDeliberationRevision"
      );

      setCanCreateDeliberation(
        hasAccessToCreateDeliberation && minuteStatus !== "C"
      );
      setCanCreateDeliberationReview(
        hasAccessToCreateDeliberationReview && minuteStatus !== "C"
      );
      load();
    }
  }, [userAccess, inputReviewerRequester, minuteStatus]);

  useEffect(() => {
    if (!finalDeliberation?.description_FinalDeliberation) {
      setFormMode("create");
    } else {
      setFormMode("viewer");

      setFinalDeliberationInputValue(
        finalDeliberations.find(
          (finalDelib) =>
            finalDelib.id === finalDeliberation?.description_FinalDeliberation
        )
      );

      setfinalDeliberationReviews(
        finalDeliberation?.finalDeliberationHistoric?.map((fd) => {
          return {
            ...fd,
            finalDeliberation:
              finalDeliberations.find(
                (option) => option.id === fd.description_FinalDeliberation
              )?.name || "",
          };
        })
      );
    }
  }, [finalDeliberation, finalDeliberations]);

  const handleAddDeliberation = async () => {
    if (!finalDeliberationInputValue.id) {
      setMessage({
        open: true,
        content: "Por favor preencha o campo de deliberação final.",
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    const response = await addFinalDeliberation({
      minuteSlotId,
      finalDeliberation: finalDeliberationInputValue.id,
    });

    if (response?.error) {
      setMessage({
        open: true,
        content: "Ocorreu um erro ao adicionar a deliberação final.",
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    loadFinalDeliberationReviews();

    setMessage({
      open: true,
      content: t("forms.minutes.actions.createDeliberationSuccess"),
      type: "success",
      autoHideDuration: 4000,
    });

    setFormMode("viewer");
  };

  const loadFinalDeliberationReviews = async () => {
    getById(minuteSlotId).then((res) => {
      setFinalDeliberation(res.finalDeliberation);
    });
  };

  const handleAddReview = async () => {
    if (!finalDeliberationInputValue.id) {
      setMessage({
        open: true,
        content: t("forms.minutes.actions.finalDeliberationFieldValidation"),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    if (!reviewerRequester.id) {
      setMessage({
        open: true,
        content: t("forms.minutes.actions.reviewerRequesterFieldValidation"),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    const response = await addFinalDeliberationRevision({
      finalDeliberationId: finalDeliberation.iD_FinalDeliberation,
      finalDeliberation: finalDeliberationInputValue.id,
      memberReviewer: authProvider.account.accountIdentifier,
      memberRequesterReviewer: reviewerRequester.id,
    });

    if (response?.error) {
      setMessage({
        open: true,
        content: t("error"),
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }

    setMessage({
      open: true,
      content: t("forms.minutes.actions.addReviewSuccess"),
      type: "success",
      autoHideDuration: 4000,
    });

    loadFinalDeliberationReviews();
    setReviewerRequester();
    setFormMode("viewer");
  };

  return (
    <>
      <Toastmessage
        message={message.content}
        type={message.type}
        open={message.open}
        autoHideDuration={message.autoHideDuration}
        close={() =>
          setMessage({
            open: false,
            content: "",
            type: "",
            autoHideDuration: 4000,
          })
        }
      />
      <ModalBase
        open={openReviewsModal}
        setOpen={setOpenReviewsModal}
        content={
          <ReviewsModal
            t={t}
            setModalStatus={(value) => setOpenReviewsModal(value)}
            finalDeliberation={finalDeliberation}
          />
        }
      />
      <Grid container direction="row" spacing={3}>
        <Grid item lg={finalDeliberationReviews?.length > 0 ? 8 : 12} xs={12}>
          <Select
            value={finalDeliberationInputValue}
            setValue={(value) => {
              setFinalDeliberationInputValue(value);
            }}
            id="finalDeliberation"
            options={finalDeliberations}
            required={true}
            disabled={
              formMode === "viewer" || !canCreateDeliberation || !isEditMode
            }
            label={
              !isEditMode ? "" : t("forms.minutes.actions.finalDeliberation")
            }
            error={!finalDeliberationInputValue && canCreateDeliberation}
          />

          {formMode === "review" && (
            <Grid container spacing={3}>
              <Grid item lg={6} xs={12} style={{ marginTop: "16px" }}>
                <Select
                  value={reviewerRequester}
                  setValue={(value) => {
                    setReviewerRequester(value);
                  }}
                  id="reviewerRequester"
                  onInputChange={(_event, newInputValue, _prop) => {
                    setInputReviewerRequester(newInputValue);
                  }}
                  inputValue={inputReviewerRequester}
                  options={reviewRequesters}
                  required={true}
                  label={t("forms.minutes.actions.reviewerRequester")}
                  error={!reviewerRequester}
                  disabled={!canCreateDeliberationReview || !isEditMode}
                />
              </Grid>
            </Grid>
          )}

          {formMode === "create" && isEditMode && (
            <div
              style={{
                display: "flex",
                marginTop: "62px",
                width: "100%",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Fab
                color="primary"
                aria-label="add"
                size="small"
                style={{ marginRight: "10px" }}
                onClick={handleAddDeliberation}
                disabled={!canCreateDeliberation}
              >
                <Add />
              </Fab>
              <span style={{ color: "#465eb6", fontWeight: "bold" }}>
                {t("forms.minutes.actions.addFinalDeliberation")}
              </span>
            </div>
          )}
          {formMode === "viewer" && isEditMode && (
            <div
              style={{
                display: "flex",
                marginTop: "62px",
                width: "100%",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Fab
                color="primary"
                aria-label="add"
                size="small"
                style={{ marginRight: "10px" }}
                onClick={() => setFormMode("review")}
                disabled={!canCreateDeliberationReview}
              >
                <Add />
              </Fab>
              <span style={{ color: "#465eb6", fontWeight: "bold" }}>
                {t("forms.minutes.actions.addReview")}
              </span>
            </div>
          )}
          {formMode === "review" && isEditMode && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "62px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  maxWidth: "200px",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Fab
                  color="primary"
                  aria-label="add"
                  size="small"
                  style={{ marginRight: "10px" }}
                  onClick={() => setFormMode("viewer")}
                >
                  <Clear />
                </Fab>
                <span style={{ color: "#465eb6", fontWeight: "bold" }}>
                  {t("forms.minutes.actions.cancelReview")}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  maxWidth: "200px",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Fab
                  color="primary"
                  aria-label="add"
                  size="small"
                  style={{ marginRight: "10px" }}
                  onClick={handleAddReview}
                  disabled={!canCreateDeliberationReview}
                >
                  <Add />
                </Fab>
                <span style={{ color: "#465eb6", fontWeight: "bold" }}>
                  {t("forms.minutes.actions.addReview")}
                </span>
              </div>
            </div>
          )}
        </Grid>

        {finalDeliberationReviews?.length > 0 && isEditMode && (
          <Grid item lg={4}>
            <div
              style={{
                border: "2px solid #bdbdbd",
                marginBottom: "8px",
                borderRadius: "8px",
                padding: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span style={{ fontSize: "16px", overflowWrap: "break-word" }}>
                A ata possui
                <strong>{` ${finalDeliberationReviews?.length} `}</strong>
                revisões de deliberação final.
              </span>
              <span style={{ fontSize: "16px", overflowWrap: "break-word" }}>
                <strong
                  style={{ color: "#031795", cursor: "pointer" }}
                  onClick={() => setOpenReviewsModal(true)}
                >
                  {`Clique aqui `}
                </strong>
                para ver o hisórico
              </span>
            </div>
          </Grid>
        )}
      </Grid>
    </>
  );
};

const withRouterFinalDeliberation = withRouter(FinalDeliberation);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const FinalDeliberationConnect = connect(
  null,
  mapDispatchToProps
)(withRouterFinalDeliberation);

export default withTranslation()(FinalDeliberationConnect);
